export default __webpack_public_path__ + "static/men-technology-zoom-fruitseeds-5c1bd79b9f7dce67cc4e0908c18cbddf.png";